(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-related"] && !Shopify.designMode) return;
  try {
    
  class RelatedArticles extends HTMLElement {
    constructor() {
      super();

      this.swiperElement = this.querySelector('[data-swiper-related-articles]');

      this.swiperOptions = {
        loop: false,
        autoplay: false,
        slidesPerView: 4,
        direction: 'horizontal'
      }

      // Check if we have extra options on the HTML
      if (this && this.dataset && this.dataset.options) {
        const jsonOptions = JSON.parse(this.dataset.options);

        if (jsonOptions) {
          this.swiperOptions = {
            ...this.swiperOptions,
            ...jsonOptions
          }
        }
      }

      this.init();
    }

    init() {
      window.addEventListener('load', (event) => {
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      });
    }
  }

  customElements.define('related-articles-swiper', RelatedArticles);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  } catch(e) { console.error(e); }
})();
})();
